/* eslint-disable react/prop-types */
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import LiquidFillGauge from "react-liquid-gauge";

const Layout3DTank = ({ data, apiData }) => {
  const ref = useRef({});
  const { chartTitle, capacity } = data;
  const [radius, setRadius] = useState(100);

  const valueNumber = Number(apiData?.data?.value || 0);
  const [value, setValue] = useState(valueNumber);
  const unit = apiData?.unit || "";

  useEffect(() => {
    setTimeout(() => {
      if (ref.current?.clientHeight) {
        const height = ref.current.clientHeight - 30 < ref.current.clientWidth ? ref.current.clientHeight - 30 : ref.current.clientWidth;
        setRadius(height);
      }
    }, 500);
  }, [ref, value, ref.current?.clientHeight, ref.current?.clientWidth, data.isTitleHidden]);

  useEffect(() => {
    if (capacity) {
      setValue(Math.abs((100 * Number(valueNumber || 0)) / Number(capacity) || 0));
    }
  }, [valueNumber, capacity]);

  const startColor = "#6495ed"; // cornflowerblue
  const endColor = "#dc143c"; // crimson

  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = interpolate(value / 100);

  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  let capacityOffset = capacity / 4;
  let capacitySteps = [];
  for (let i = 0; i <= capacity; i += capacityOffset) {
    capacitySteps.unshift(
      <p
        className="m-0"
        style={{
          fontSize: "13px",
          fontWeight: "400",
        }}
        key={i}
      >
        {Math.round(i)} {unit}
      </p>,
    );
  }

  return (
    <div className="h-100 w-100 p-3 d-flex flex-column">
      {!data.isTitleHidden && (
        <div className="ql">
          <div className="ql-editor text-center pt-0">
            <div dangerouslySetInnerHTML={{ __html: chartTitle }}></div>
          </div>
        </div>
      )}

      <div ref={ref} className="flex-1 d-flex align-items-center justify-content-center">
        <LiquidFillGauge
          style={{ margin: "0 auto" }}
          width={radius}
          height={radius}
          value={value}
          percent="%"
          textSize={1}
          textOffsetX={0}
          textOffsetY={0}
          textRenderer={(props) => {
            const roundedValue = Math.round(props.value);
            const radius = Math.min(props.height / 2, props.width / 2);
            const textPixels = (props.textSize * radius) / 2;
            const valueStyle = {
              fontSize: textPixels,
            };
            const percentStyle = {
              fontSize: textPixels * 0.6,
            };

            return (
              <tspan>
                <tspan className="value" style={valueStyle}>
                  {roundedValue}
                </tspan>
                <tspan style={percentStyle}>{props.percent}</tspan>
              </tspan>
            );
          }}
          riseAnimation
          waveAnimation
          waveFrequency={2}
          waveAmplitude={1}
          gradient
          gradientStops={gradientStops}
          circleStyle={{
            fill: fillColor,
          }}
          waveStyle={{
            fill: fillColor,
          }}
          textStyle={{
            fill: color("#444").toString(),
            fontFamily: "Arial",
          }}
          waveTextStyle={{
            fill: color("#fff").toString(),
            fontFamily: "Arial",
          }}
        />
      </div>
      <h5 className="text-center">
        {valueNumber.toFixed(2)} {unit && `(${unit})`}
      </h5>
    </div>
  );
};

export default Layout3DTank;

Layout3DTank.propTypes = {
  data: PropTypes.object.isRequired,
  mainDashboard: PropTypes.bool,
  apiData: PropTypes.object,
};
